<template>

<fragment>

	<core-button v-on:click.native="onPreviousClick" theme="filter" :disabled="!hasPrevious" class="filter-bar-button filter-bar-button-caret is-left" icon="caret-left" :iconOnly="true" v-if="!isLive && !window.is.mobile"></core-button>

	<core-dropdown class="filter-edition" trigger="manual" v-on:forceClose="is.expanded.editions = false" :expanded="is.expanded.editions" v-click-outside="onOutsideClick" v-if="!isLive">

		<core-button type="filter" theme="filter" class="filter-edition-button filter-bar-button" :caret="true" :icon="($isMobile) ? 'calendar' : false" :iconLeft="$isMobile" v-on:click.native="onEditionsClick">{{ name }}</core-button>

		<core-dropdown-list title="Editions" :expanded="is.expanded.editions" class="filter-edition-list filter-edition-list-slim" v-if="isYearly" theme="filter" :caret="true" v-propagation v-on:close="is.expanded.editions = false">
				
			<core-dropdown-item v-on:click.native="onEditionClick(year.slug)" v-for="year in years" v-bind:key="year.slug" :active="year.slug === edition.slug">{{ year.name }}</core-dropdown-item>

		</core-dropdown-list>
			
		<core-dropdown-list title="Editions" :expanded="is.expanded.editions"  class="filter-edition-list" v-if="!isYearly" grouped="true" theme="filter" :caret="true" v-propagation v-on:close="is.expanded.editions = false">

			<div class="filter-edition-list-inner">
				
				<div class="filter-edition-list-group" v-for="group in editionsGrouped" v-bind:key="group.year">

					<core-dropdown-item type="title">{{ group.year }}</core-dropdown-item>

					<core-dropdown-item v-on:click.native="onEditionClick(item.slug)" v-for="item in group.editions" v-bind:key="item.slug" :active="item.slug === edition.slug">{{ item.name }}</core-dropdown-item>

				</div>

			</div>

		</core-dropdown-list>

	</core-dropdown>

	<core-button v-on:click.native="onNextClick" theme="filter" :disabled="!hasNext" class="filter-bar-button filter-bar-button-caret is-right" icon="caret-right" :iconOnly="true" v-if="!isLive && !window.is.mobile"></core-button>

</fragment>

</template>

<script>

import vClickOutside from 'v-click-outside'

export default {
	
	directives: {
		clickOutside: vClickOutside.directive
	},

	data: function() {

		return {
			is: {
				expanded: {
					editions: false
				}
			}
		}

	},

	computed: {

		isLive: function() {

			return this.list.frequency === this.$CONSTANTS.LISTS.FREQUENCY.LIVE

		},
		
		isYearly: function() {

			return this.list.frequency === this.$CONSTANTS.LISTS.FREQUENCY.YEARLY

		},

		list: function() {

			return this.$store.getters['page/list/list']

		},

		context: function() {

			return this.$store.getters['context']

		},

		edition: function() {

			return this.$store.getters['page/list/edition']

		},

		editions: function() {

			return this.$store.getters['page/list/editions']

		},

		name: function() {

			return this.edition.name

		},

		editionsGrouped: function() {

			var grouped = []

			var currentGroup = {
				year: false,
				editions: []
			}

			this.$_.each(this.editions, function(edition) {

				if (this.$moment.unix(edition.date).utc().format('YYYY') !== currentGroup.year) {

					if (currentGroup.editions.length) {

						currentGroup.editions.reverse()

						grouped.push({
							year: currentGroup.year,
							editions: this.$_.clone(currentGroup.editions)
						})

					}

					currentGroup = {
						year: this.$moment.unix(edition.date).utc().format('YYYY'),
						editions: []
					}

				}

				edition.name = edition.name.replace(currentGroup.year, '').trim()

				currentGroup.editions.push(edition)

			}.bind(this))

			currentGroup.editions.reverse()

			grouped.push(currentGroup)

			grouped.reverse()

			return grouped

		},

		years: function() {

			var years = []

			this.$_.each(this.editions, function(edition) {

				years.push(edition)

			})

			return years.reverse()

		},

		hasPrevious: function() {

			return this.$_.filter(this.editions, function(edition) {

				return edition.date < this.edition.date

			}.bind(this)).length

		},

		hasNext: function() {

			return !this.edition.current

		}

	},

	watch: {

		context: function(newValue, oldValue) {

			if (newValue.type !== oldValue.type || newValue.name !== oldValue.name) {

				this.is.expanded.editions = false

			}

		}

	},

	methods: {

		onEditionsClick: function() {

			this.is.expanded.editions = !this.is.expanded.editions

		},

		onEditionClick: function(slug) {

			this.$routerPush({
				name: 'Edition',
				params: {
					list: this.list.slug,
					edition: slug
				}
			}).catch(function(e) { console.log(e) })

		},

		onOutsideClick: function() {

			this.is.expanded.editions = false

		},

		onPreviousClick: function() {

			if (this.hasPrevious) {

				var previous = this.$_.last(this.$_.filter(this.editions, function(edition) {

					return edition.date < this.edition.date

				}.bind(this)))

				this.$routerPush({
					name: 'Edition',
					params: {
						list: this.list.slug,
						edition: previous.slug
					}
				}).catch(function(e) { console.log(e) })

			}

		},

		onNextClick: function() {

			if (this.hasNext) {

				var previous = this.$_.first(this.$_.filter(this.editions, function(edition) {

					return edition.date > this.edition.date

				}.bind(this)))

				this.$routerPush({
					name: 'Edition',
					params: {
						list: this.list.slug,
						edition: previous.slug
					}
				}).catch(function(e) { console.log(e) })

			}

		}

	}

}

</script>

<style scoped>

</style>